import { all, takeEvery, put, call, fork } from 'redux-saga/effects';
import LabelHelper from '@iso/lib/api/labelsHelper';
import { notification } from '@iso/components';
import actions from './actions';
//import JwtAuthentication from '../../helpers/jwtAuthentication';

/**** list of user record *******/
function* LabelReadRequest() {
    yield takeEvery(actions.LABEL_LIST, function*({ payload }) {
    try {
        //const {page}=payload.page;
      const searchResult = yield call(LabelHelper.read,payload);
      console.log('---serachResult-- label', searchResult )
      if (searchResult.status) {
        yield put(
          actions.labelListSuccess(
          searchResult.exportresult,  
          searchResult.result,
          searchResult.status,
          searchResult.totalRecordCount,
          searchResult.grpfilter,
           payload.page
          )
        );
      } else {
        notification("error", searchResult.message);
        yield put(
          actions.labelListSuccess([],  [],0,0,{}, 0)
        );
      }
    } catch (error) {
    }
  });
}
/*****fetch user record  *************/



/**** list of user record *******/
export  function* LabelFindByIdRequest() {
  console.log('search request');
    yield takeEvery(actions.LABEL_FETCH_ID, function*({ payload }) {
    try {
      const searchResult = yield call(LabelHelper.findById,payload.listid);
      console.log('---serachResult--', searchResult )

      if (searchResult.status) {
        yield put(
          actions.labelListById(
          searchResult.result,
          searchResult.message
          )
        );
      } else {
      }
    } catch (error) {
    }
  });
}
/*****end*************/




/************************************** End UPDATE User  Function ***************************************/

export default function* rootSaga() {
  yield all([
    //  takeEvery(actions.USER_LIST, searchRequest)
    fork(LabelReadRequest),
    fork(LabelFindByIdRequest),
  ]);
}
